import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(landing)/alternative/coworking-varese-next/page.client.tsx");
